import * as React from 'react';
import { DSMenuItemProps, DSMenuItem } from '../mui/MenuItem';
import { useHandleClose } from './handle-close.context';

export const ActionMenuItem = React.forwardRef<HTMLLIElement, Omit<DSMenuItemProps, 'css'>>((props, ref) => {
    const handleClose = useHandleClose();
    const handleOnClick = (ev: React.MouseEvent<HTMLLIElement>) => {
        handleClose?.(ev);
        props.onClick?.(ev);
    };
    return (
        <DSMenuItem {...props} button={false} ref={ref} onClick={handleOnClick}>
            {props.children}
        </DSMenuItem>
    );
});
ActionMenuItem.displayName = 'ActionMenuItem';
